const state = () => ({
  DataFrom: {
    stu_sms_stu: "",
    stu_card_id: "",
    stu_year_entry: "",
    tes_id: "",

    select_year: "",

    linkfrom: "",
  },
  DataStepFrom1: [],
  DataYearSignup: [],
  DataPDPA: [],
  statusUpdatePDPA: [],
});
/* ========== getters ========== */
const getters = {
  _getDataFrom: (state) => {
    return state.DataFrom;
  },
  _getDataStepFrom1: (state) => {
    return state.DataStepFrom1;
  },
  _getDataYearSignup: (state) => {
    return state.DataYearSignup;
  },
  _getDataPDPA: (state) => {
    return state.DataPDPA;
  },
  _getstatusUpdatePDPA: (state) => {
    return state.statusUpdatePDPA;
  },
};
/* ========== actions ========== */
const actions = {
  async SetStepStatus({ state, rootState }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      // console.log(state.DataFrom);
      const response = await window.Axios.post(
        `${window.api}exec/GetStepStatus/`,
        state.DataFrom
      );
      rootState.Main.DataStep = response.data;
      rootState.Main.tes_id = response.data.tes_id;
      state.DataFrom.tes_id = response.data.tes_id;
      state.DataStepFrom1 = response.data;
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataYearSignup({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetYearSignup/`
      );
      await commit("GET_DataYearSignup", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async postDataPDPA({ commit, state }) {
    try {
      // console.log(state.DataFrom);
      const response = await window.Axios.post(
        `${window.api}post/postDataPDPA/`,
        state.DataFrom
      );
      await commit("postDataPDPA", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async UPDATE_PDPA({ commit, state }) {
    try {
      // console.log(state.DataFrom);
      const response = await window.Axios.post(
        `${window.api}exec/UPDATE_PDPA/`,
        state.DataFrom
      );
      await commit("UPDATE_PDPA", response.data);
    } catch (error) {
      console.error(error);
    }
  },
};

/* ========== mutations ========== */
const mutations = {
  GET_DataYearSignup(state, payload) {
    state.DataYearSignup = payload;
  },
  postDataPDPA(state, payload) {
    state.DataPDPA = payload;
  },
  UPDATE_PDPA(state, payload) {
    state.statusUpdatePDPA = payload;
  },
};

/* ========== Export ========== */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
